// utils/prettyUrl.js

export const generatePrettyUrl = (id, title) => {
  if (!title) return "";

  // Normalize the title to remove accents
  const normalizedTitle = title
    .normalize("NFD") // Decomposes characters and separates base characters from their accents
    .replace(/[\u0300-\u036f]/g, ""); // Removes accents (Combining diacritical marks)

  // Create the pretty URL
  const prettyUrl =
    id +
    "-" +
    normalizedTitle
      .toLowerCase()
      .trim()
      .replace(/[\s]+/g, "-") // Replace spaces with hyphens
      .replace(/[^a-z0-9-]/g, ""); // Remove special characters // keeps letters like é or à but will convert to e or a

  return prettyUrl;
};
